var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "faq-area" }, [
    _c("div", { staticClass: "faq-box" }, [
      _c("div", { staticClass: "text-area" }, [
        _c("h1", [
          _vm._v("\n        " + _vm._s(_vm.$t("faq.header")) + "\n      "),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "desc" }, [
          _vm._v("\n        " + _vm._s(_vm.$t("faq.description")) + "\n      "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "image-area" }, [
        _c("div", { staticClass: "picture" }, [
          _c(
            "picture",
            [
              _c("source", {
                attrs: { srcset: "/img/new/faq.webp", type: "image/webp" },
              }),
              _vm._v(" "),
              _c("nuxt-img", {
                attrs: {
                  fit: "inside",
                  width: "812",
                  sizes: "sm:300px md:400px lg:500px xl:500px xxl:600px",
                  src: "/img/new/faq.png",
                  alt: "Question answers on Defi Pool Finance about blockchain interactions",
                  title: "Defi Pool FAQ",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cyan-cloud" }, [_c("CloudCyanVotingRight")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "cyan-cloud2" }, [_c("CloudCyanVotingLeft")], 1),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "questions" }, [
      _c("div", { staticClass: "question-area" }, [
        _c(
          "div",
          {
            class: { question: true, active: _vm.currentTab === 0 },
            on: {
              click: function ($event) {
                return _vm.changeTab(0)
              },
            },
          },
          [
            _c("div", { staticClass: "icon" }, [_c("Flamingo")], 1),
            _vm._v(" "),
            _c("div", { staticClass: "h6" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("faq.what_is_defipool")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "chevron" }, [_c("ChevronDown")], 1),
          ]
        ),
        _vm._v(" "),
        _c("div", { ref: "accordion0", staticClass: "answer" }, [
          _c(
            "p",
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("faq.what_is_defipool_p1")) +
                  " \n          "
              ),
              _c(
                "nuxt-link",
                { attrs: { to: _vm.localePath("/docs#roadmap") } },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("faq.here")) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(".\n        "),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "question-area" }, [
        _c(
          "div",
          {
            class: { question: true, active: _vm.currentTab === 1 },
            on: {
              click: function ($event) {
                return _vm.changeTab(1)
              },
            },
          },
          [
            _c("div", { staticClass: "icon" }, [_c("Security")], 1),
            _vm._v(" "),
            _c("div", { staticClass: "h6" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("faq.how_to_unstake")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "chevron" }, [_c("ChevronDown")], 1),
          ]
        ),
        _vm._v(" "),
        _c("div", { ref: "accordion1", staticClass: "answer" }, [
          _c("p", [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("faq.how_to_unstake_p1")) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("faq.how_to_unstake_p2")) +
                "\n        "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "question-area" }, [
        _c(
          "div",
          {
            class: { question: true, active: _vm.currentTab === 2 },
            on: {
              click: function ($event) {
                return _vm.changeTab(2)
              },
            },
          },
          [
            _c("div", { staticClass: "icon" }, [_c("Puzzle")], 1),
            _vm._v(" "),
            _c("div", { staticClass: "h6" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("faq.provide_liquidity")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "chevron" }, [_c("ChevronDown")], 1),
          ]
        ),
        _vm._v(" "),
        _c("div", { ref: "accordion2", staticClass: "answer" }, [
          _c("p", [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("faq.provide_liquidity_p1")) +
                "\n        "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "question-area" }, [
        _c(
          "div",
          {
            class: { question: true, active: _vm.currentTab === 3 },
            on: {
              click: function ($event) {
                return _vm.changeTab(3)
              },
            },
          },
          [
            _c("div", { staticClass: "icon" }, [_c("CryptoCoin")], 1),
            _vm._v(" "),
            _c("div", { staticClass: "h6" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("faq.why_my_transaction")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "chevron" }, [_c("ChevronDown")], 1),
          ]
        ),
        _vm._v(" "),
        _c("div", { ref: "accordion3", staticClass: "answer" }, [
          _c("p", [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("faq.why_my_transaction_p1")) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("faq.why_my_transaction_p2")) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("faq.why_my_transaction_p3")) +
                "\n        "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "question-area" }, [
        _c(
          "div",
          {
            class: { question: true, active: _vm.currentTab === 4 },
            on: {
              click: function ($event) {
                return _vm.changeTab(4)
              },
            },
          },
          [
            _c("div", { staticClass: "icon" }, [_c("CoinHold")], 1),
            _vm._v(" "),
            _c("div", { staticClass: "h6" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("faq.receive_airdrops")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "chevron" }, [_c("ChevronDown")], 1),
          ]
        ),
        _vm._v(" "),
        _c("div", { ref: "accordion4", staticClass: "answer" }, [
          _c("p", [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("faq.receive_airdrops_p1")) +
                "\n        "
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "answers" }, [
      _c(
        "div",
        { ref: "tab0", class: { answer: true, active: _vm.currentTab === 0 } },
        [
          _c(
            "p",
            { staticClass: "no-flex" },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("faq.what_is_defipool_p1")) + " "
              ),
              _c("nuxt-link", { attrs: { to: _vm.localePath("/roadmap") } }, [
                _vm._v(_vm._s(_vm.$t("faq.here"))),
              ]),
              _vm._v(".\n      "),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "tab1", class: { answer: true, active: _vm.currentTab === 1 } },
        [
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("faq.how_to_unstake_p1")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("faq.how_to_unstake_p2")) +
                "\n      "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "tab2", class: { answer: true, active: _vm.currentTab === 2 } },
        [
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("faq.provide_liquidity_p1")) +
                "\n      "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "tab3", class: { answer: true, active: _vm.currentTab === 3 } },
        [
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("faq.why_my_transaction_p1")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("faq.why_my_transaction_p2")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("faq.why_my_transaction_p3")) +
                "\n      "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "tab4", class: { answer: true, active: _vm.currentTab === 4 } },
        [
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("faq.receive_airdrops_p1")) +
                "\n      "
            ),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feedback-area" }, [
      _c("div", { staticClass: "image-area" }, [
        _c(
          "picture",
          [
            _c("source", {
              attrs: { srcset: "/img/new/lifeguard.webp", type: "image/webp" },
            }),
            _vm._v(" "),
            _c("nuxt-img", {
              attrs: {
                fit: "inside",
                width: "928",
                sizes: "sm:275px md:300px lg:400px xl:500px xxl:600px",
                src: "/img/new/lifeguard.png",
                alt: "Blockchain qustions answered on Defi Pool Finance",
                title: "FAQ answering form",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "p",
          [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("faq.for_more_info")) + " \n        "
            ),
            _c("nuxt-link", { attrs: { to: _vm.localePath("/docs") } }, [
              _vm._v(
                "\n          " + _vm._s(_vm.$t("faq.pool_rules")) + "\n        "
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-area" }, [
        _c("div", { staticClass: "h4" }, [
          _vm._v("\n        " + _vm._s(_vm.$t("faq.lifeguard")) + "\n      "),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "desc" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("faq.lifeguard_desc")) + "\n      "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form" }, [
          _c("div", { staticClass: "input mr-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.feedback.name,
                  expression: "feedback.name",
                },
              ],
              attrs: { type: "text", placeholder: _vm.$t("faq.name") + " *" },
              domProps: { value: _vm.feedback.name },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.feedback, "name", $event.target.value)
                  },
                  _vm.validateName,
                ],
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "nameError",
                class: {
                  "error-message": true,
                  active: _vm.errors.name.length > 0,
                },
                attrs: { tooltip: _vm.errors.name },
              },
              [_c("ErrorSign")],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "input mr-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.feedback.email,
                  expression: "feedback.email",
                },
              ],
              attrs: { type: "email", placeholder: _vm.$t("faq.email") + " *" },
              domProps: { value: _vm.feedback.email },
              on: {
                change: _vm.validateEmail,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.feedback, "email", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "emailError",
                class: {
                  "error-message": true,
                  active: _vm.errors.email.length > 0,
                },
                attrs: { tooltip: _vm.errors.email },
              },
              [_c("ErrorSign")],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "input" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.feedback.telegram,
                  expression: "feedback.telegram",
                },
              ],
              attrs: { type: "text", placeholder: _vm.$t("faq.telegram") },
              domProps: { value: _vm.feedback.telegram },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.feedback, "telegram", $event.target.value)
                  },
                  _vm.validateNickname,
                ],
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "telegramError",
                class: {
                  "error-message": true,
                  active: _vm.errors.telegram.length > 0,
                },
                attrs: { tooltip: _vm.errors.telegram },
              },
              [_c("ErrorSign")],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "input w-100" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.feedback.message,
                  expression: "feedback.message",
                },
              ],
              attrs: {
                type: "text",
                placeholder: _vm.$t("faq.message") + " *",
                rows: "3",
              },
              domProps: { value: _vm.feedback.message },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.feedback, "message", $event.target.value)
                  },
                  _vm.validateMessage,
                ],
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "messageError",
                class: {
                  "error-message": true,
                  active: _vm.errors.message.length > 0,
                },
                attrs: { tooltip: _vm.errors.message },
              },
              [_c("ErrorSign")],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "buttons-area" }, [
          _c(
            "button",
            {
              staticClass: "btn cyan",
              attrs: { type: "submit" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.sendFeedback.apply(null, arguments)
                },
              },
            },
            [
              !_vm.feedbackLoading
                ? _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("faq.send_message")) +
                        "\n          "
                    ),
                  ])
                : _c("span", [_c("Loading")], 1),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }